export default __webpack_public_path__ + "static/media/gilroy-medium.f63593fd.ttf";